import { render } from "./tram.vue?vue&type=template&id=7eb7a42e"
import script from "./tram.vue?vue&type=script&lang=js"
export * from "./tram.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__